import api from './api';

const upgradePlan = async (planId) => {
    const response = await api.post('/payments/upgrade/', { plan_id: planId });
    return response.data;
};

const subscriptionService = {
    upgradePlan,
};

export default subscriptionService;
